import { render, staticRenderFns } from "./PageConfirmEmailView.vue?vue&type=template&id=56413f96&scoped=true&"
import script from "./PageConfirmEmailView.vue?vue&type=script&lang=js&"
export * from "./PageConfirmEmailView.vue?vue&type=script&lang=js&"
import style0 from "./PageConfirmEmailView.vue?vue&type=style&index=0&id=56413f96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56413f96",
  null
  
)

export default component.exports